<div class="header">
  <div>
    <img src="../assets/images/header.png" alt=""/>
  </div>
  <div class="title">
    <div>
      {{ 'STM - Portal' | translate }}
    </div>
    <div id="log-out" (click)="showLogoutOptions()">
      <div>{{ userName }}</div>
      <div>
        <object data="../assets/images/user-icon.svg" [width]="50" [height]="40"></object>
      </div>
    </div>
  </div>
</div>
<dx-popover [target]="'#log-out'"
            [position]="'bottom'"
            [(visible)]="isLogoutMenuVisible"
            [contentTemplate]="'logoutContent'">
  <dxo-animation>
    <dxo-show [type]="'pop'" [from]="{ scale: 0 }" [to]="{ scale: 1 }"></dxo-show>
    <dxo-hide [type]="'fade'" [from]="1" [to]="0"></dxo-hide>
  </dxo-animation>
  <div *dxTemplate="let data of 'logoutContent'">
    <div class="log-out-templates-container">
      <div class="log-out-template" (click)="about()">
        <div>
          <object data="../assets/images/about.svg" [width]="20" [height]="20"></object>
        </div>
        <div translate>About</div>
      </div>
      <div class="log-out-template red" (click)="logout()">
        <div>
          <object data="../assets/images/logout.svg" [width]="20" [height]="20"></object>
        </div>
        <div translate>Logout</div>
      </div>
    </div>
  </div>
</dx-popover>
<ng-container *ngIf="isAuthorized; then authorized else unauthorized"></ng-container>

<ng-template #authorized>
  <div class="content">
    <dx-toolbar [items]="toolbarContent"></dx-toolbar>
    <dx-drawer [openedStateMode]="selectedOpenMode"
               [position]="selectedPosition"
               [revealMode]="selectedRevealMode"
               [(opened)]="isDrawerOpen"
               [height]="getDrawerHeight()"
               [closeOnOutsideClick]="false"
               template="template">
      <div *dxTemplate="let data of 'template'" class="drawer-template">
        <dx-scroll-view [height]="getDrawerHeight()" [useNative]="true">
          <dx-tree-view [dataSource]="divisionsDataSource" (onItemClick)="treeViewItemClicked($event)"></dx-tree-view>
        </dx-scroll-view>
      </div>
      <div id="view">
        <router-outlet></router-outlet>
      </div>
    </dx-drawer>
    <app-incident></app-incident>
    <app-report></app-report>
    <app-reference></app-reference>
    <app-about [(isVisible)]="isAboutDialogVisible" [details]="applicationInformation"></app-about>
  </div>
</ng-template>

<div class="footer" [ngClass]="{ 'authorization-started': isAuthorizationInProgress }">
  <a href="https://www.k3v.de/" target="_blank" class="home-page-link">
    <div>
      <img src="../assets/images/footer.png" alt=""/>
    </div>
    <div class="copyright">
      {{ 'Copyright © 2016-2022 K3V Solutions AG' | translate }}
    </div>
  </a>
</div>

<ng-template #unauthorized>
  <app-authorization></app-authorization>
</ng-template>

<dx-load-panel [visible]="isLoadPanelVisible"
               [shadingColor]="shadingColor"
               [showIndicator]="true"
               [shading]="true"
               [message]="'Processing...' | translate"
               [closeOnOutsideClick]="false">
</dx-load-panel>
